import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { UserSettings } from '../../global/user-settings.dto';
import { ILoginForm } from '../../main/pages/authentication/auth-login/auth-login.component';
import { IUserDataDto } from './IUser-data.dto';

const scope = '[Auth]';

export const login = createAction(`${scope} Login`, props<{ credentials: ILoginForm, end_user: boolean, isThirdPartyLogin: boolean }>());
export const loadAuthData = createAction(`${scope} Load Auth Data`);
export const loadCrmData = createAction(`${scope} Load CRM Data`, (crmData) => ({ crmData }));
export const loginSuccess = createAction(`${scope} Login Success`, props<{ userData: UserSettings, isThirdPartyLogin: boolean, formData: IUserDataDto }>());
export const loginFailure = createAction(`${scope} Login Failure`, props<{ error: string }>());
export const loginBlocked = createAction(`${scope} Login Blocked`, props<{ expiresAt: number, message?: string }>());
export const addUserSettings = createAction(`${scope} Add User Settings`, props<{ userSettings: UserSettings }>());
export const clearState = createAction(`${scope} Clear Auth State`);
export const fetchUserData = createAction(`${scope} Fetch User Data`);
export const fetchUserDataSucceeded = createAction(`${scope} Fetch User Data Succeeded`, props<{ userData: UserSettings }>());
export const fetchUserDataFailed = createAction(`${scope} Fetch User Data Failed`, props<{ error: HttpErrorResponse }>());

export const fetchUserSettings = createAction(`${scope} Fetch User Settings`);
export const fetchUserSettingsFailed = createAction(`${scope} Fetch User Settings Failed`, (error: string) => ({ error }));

export const stayLoggedIn = createAction(`${scope} Stay Logged In`, props<{ stayLoggedIn: boolean }>());
export const logout = createAction(`${scope}  logout`);
export const logoutSuccess = createAction(`${scope}  logout Success`);
export const logoutFail = createAction(`${scope}  logout Failure`, props<{ error: HttpErrorResponse }>());

export const swtichAndRedirectUser = createAction(`${scope} Swtich and redirect user`, props<{ token: string, key?: string }>());
export const swtichAndRedirectUserSuccess = createAction(`${scope} Swtich and redirect user Success`, props<{ userData: UserSettings }>());
export const swtichAndRedirectUserFail = createAction(`${scope} Swtich and redirect user fail`);


export const markAsLoogedIn = createAction(`${scope} Mark as logged in`)//TODO: temporary fix while BE will allow to connect from localhost

export const scheduleRefreshSession = createAction(`${scope} Schedule Refresh Session`);
export const refreshSession = createAction(`${scope} Refresh Session`);
export const refreshSessionSuccess = createAction(`${scope} Refresh Session Succeeded`);
export const refreshSessionFailed = createAction(`${scope} Refresh Session Failed`, props<{ error: HttpErrorResponse }>());

export const startEditorSessionKeepAlive = createAction(`${scope} Start Editor Session Keep Alive`);
export const stopEditorSessionKeepAlive = createAction(`${scope} Stop Editor Session Keep Alive`);

export const verifyOtp = createAction(`${scope} Verify OTP`, (otp: string) => ({ otp }));
export const verifyOtpSuccess = createAction(`${scope} Verify OTP Success`, (userData: UserSettings) => ({ userData }));
export const verifyOtpFailure = createAction(`${scope} Verify OTP Failure`, (error: string) => ({ error }));

export const iframeableLogin = createAction(`${scope} Iframe Able Login`, (userData: UserSettings, templateId: number) => ({ userData, templateId }));
export const iframeableCreateDocument = createAction(`${scope} Iframe Able Create Document`, (templateId: number) => ({ templateId }));
export const iframeableCreateDocumentSuccess = createAction(`${scope} Iframe Able Create Document Success`, (documentId: number) => ({ documentId }));
export const iframeableCreateDocumentFailure = createAction(`${scope} Iframe Able Create Document Failure`, (error: string) => ({ error }));
export const setIframeState = createAction(`${scope} Set Iframe State`, (isIframeable: boolean) => ({ isIframeable }));

export const hubspotTrackingData = createAction(`${scope} Hubspot Tracking Data`);
export const hubspotTrackingDataSuccess = createAction(`${scope} Hubspot Tracking Data Success`);
export const hubspotTrackingDataFailure = createAction(`${scope} Hubspot Tracking Data Failure`, (error: string) => ({error}));

export const ssoLogin = createAction(`${scope} SSO Login`, props<{ email: string }>());
export const ssoLoginSuccess = createAction(`${scope} SSO Login Success`, props<{ url?: string }>());
export const ssoLoginFailure = createAction(`${scope} SSO Login Failure`, props<{ error: string }>());
export const clearAuthError = createAction(`${scope} Clear Auth Error`);
